import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { FormattedHTMLMessage } from 'react-intl';
import {
  ModalContentFormatted,
  NilDetails,
  NilDetailsImagePath,
  NilDetailsTab,
  NilDetailsWarningDiv,
  NilDetailsWrapper,
  NilDetailsWrapperDesktop,
  NilDetailsWrapperTab,
  NilText,
  NilTextTab
} from './beneficiarySectionStyles';
import warningIcon from '../../../assets/images/warningBlue.svg';
import ModalPopUp from '../../../common/modal/PopUpTemplate';
import { ShowIfMobile } from '../../../utils/showIf';

const BeneficiaryNilNameField = (props, context) => {
  const {
    intl: { formatMessage }
  } = context;
  const { beneficiaryName, missingInfoFlag, maskingFlag } = props;
  const isNameFieldEmpty = _.isEmpty(beneficiaryName);
  const [isModalOpen, updateModalState] = useState(false);
  const showMissingInfoPopup = isNameFieldEmpty || missingInfoFlag;
  const renderNilTextDiv = () => {
    return (
      <NilDetailsWarningDiv
        role="alert"
        type="button"
        aria-live="assertive"
        onClick={() => {
          updateModalState(!isModalOpen);
        }}
        id="nilDetailsWarningLinkName"
      >
        <NilDetailsImagePath src={warningIcon} alt="warning-icon" />
        <NilDetails>
          {formatMessage({ id: 'modalDetailsMissingTitle' })}
        </NilDetails>
      </NilDetailsWarningDiv>
    );
  };
  return (
    <NilDetailsWrapper>
      <>
        <NilDetailsWrapperDesktop>
          <NilText className={`isMask${maskingFlag}`}>
            {isNameFieldEmpty
              ? formatMessage({ id: 'nilText' })
              : beneficiaryName}
          </NilText>
        </NilDetailsWrapperDesktop>
        <ShowIfMobile>
          <NilDetailsWrapperTab>
            <NilTextTab
              className={`isMask${maskingFlag}`}
              isNameFieldEmpty={showMissingInfoPopup}
            >
              {isNameFieldEmpty
                ? formatMessage({ id: 'nilText' })
                : beneficiaryName}
            </NilTextTab>

            <NilDetailsTab maskingFlag={showMissingInfoPopup && maskingFlag}>
              {showMissingInfoPopup && renderNilTextDiv()}
            </NilDetailsTab>
          </NilDetailsWrapperTab>
        </ShowIfMobile>
      </>

      <ModalPopUp
        isModalOpen={isModalOpen}
        onClose={() => {
          updateModalState(!isModalOpen);
        }}
        modalHeading={formatMessage({ id: 'modalDetailsMissingTitle' })}
        id="nilDetailsModal"
      >
        <ModalContentFormatted>
          <FormattedHTMLMessage id="modalDetailsMissingDescription1" />
        </ModalContentFormatted>
      </ModalPopUp>
    </NilDetailsWrapper>
  );
};

BeneficiaryNilNameField.propTypes = {
  beneficiaryName: PropTypes.string.isRequired,
  missingInfoFlag: PropTypes.bool.isRequired,
  maskingFlag: PropTypes.bool.isRequired
};

BeneficiaryNilNameField.contextTypes = {
  intl: PropTypes.object.isRequired
};

export default BeneficiaryNilNameField;
